<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="广告链接" prop="advertisementUrl">-->
<!--                <a-input v-model="queryParam.advertisementUrl" placeholder="请输入广告链接" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="是否启用 0-否 1-是" prop="isOpen">-->
<!--                <a-input v-model="queryParam.isOpen" placeholder="请输入是否启用 0-否 1-是" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <template v-if="advanced">
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="解锁秒数" prop="unlockSeconds">-->
<!--                  <a-input v-model="queryParam.unlockSeconds" placeholder="请输入解锁秒数" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
<!--                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>-->
<!--                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>-->
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['video:advertisement:add']">
          <a-icon type="plus" />新增
        </a-button>
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['video:advertisement:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['video:advertisement:remove']">
          <a-icon type="delete" />删除
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['video:advertisement:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 绑定剧集 -->
      <bind-episode-form
        ref="bindEpisodeForm"
        :visible="bindEpisodeVisible"
        :advertisementId="currentAdvertisementId"
        @ok="handleBindEpisodeOk"
        @cancel="handleBindEpisodeCancel"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >


        <span slot="advertisementUrl" slot-scope="text, record">
          <div v-if="isVideoUrl(record.advertisementUrl)" class="video-preview-wrapper">
            <video
              :src="record.advertisementUrl"
              controls
              style="width: 100%; max-width: 300px; max-height: 200px; border-radius: 4px;"
            >
              您的浏览器不支持 video 标签。
            </video>
          </div>
          <div v-else style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
            <a :href="record.advertisementUrl" target="_blank">
              {{ record.advertisementUrl }}
            </a>
          </div>
        </span>
        <span slot="isOpen" slot-scope="text, record">
          <a-switch checkedChildren="启用" unCheckedChildren="封禁" v-model="record.isOpen == 1" @change="changeIsOpen($event,record)"/>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['video:advertisement:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['video:advertisement:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['video:advertisement:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['video:advertisement:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageAdvertisement,changeIsOpen, delAdvertisement } from '@/api/video/advertisement'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Advertisement',
  components: {
    CreateForm,
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 绑定剧集相关
      bindEpisodeVisible: false,
      currentAdvertisementId: null,
      // 查询参数
      queryParam: {
        advertisementUrl: null,
        isOpen: null,
        unlockSeconds: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: '${comment}',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '广告链接',
          dataIndex: 'advertisementUrl',
          scopedSlots: { customRender: 'advertisementUrl' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'isOpen',
          ellipsis: true,
          scopedSlots: { customRender: 'isOpen' },
          align: 'center'
        },
        {
          title: '解锁秒数',
          dataIndex: 'unlockSeconds',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询广告列表 */
    getList () {
      this.loading = true
     pageAdvertisement(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    changeIsOpen (e,record) {
      record.isOpen = e ? 1 : 0
      changeIsOpen(record).then(response => {
        this.$message.success(
          '操作成功'
        )
        return  record.isOpen = e ? 1 : 0
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        advertisementUrl: undefined,
        isOpen: undefined,
        unlockSeconds: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delAdvertisement(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          // that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('video/advertisement/export', {
            ...that.queryParam
          }, `广告_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    /** 判断是否为视频链接 */
    isVideoUrl (url) {
      if (!url || typeof url !== 'string') {
        return false
      }
      // 视频文件扩展名
      const videoExtensions = ['.mp4', '.avi', '.mov', '.wmv', '.flv', '.webm', '.mkv', '.m4v', '.3gp', '.ogv']
      const lowerUrl = url.toLowerCase()
      // 检查URL是否包含视频扩展名
      return videoExtensions.some(ext => lowerUrl.includes(ext)) ||
             lowerUrl.includes('video') ||
             lowerUrl.includes('vod') ||
             lowerUrl.includes('.m3u8') // HLS流媒体
    },
    /** 绑定剧集 */
    handleBindEpisode (record) {
      this.currentAdvertisementId = record.id
      this.bindEpisodeVisible = true
    },
    /** 绑定剧集确定 */
    handleBindEpisodeOk (formData) {
      // TODO: 调用绑定接口
      console.log('绑定剧集数据:', formData)
      this.$message.success('绑定成功')
      // 这里可以调用实际的绑定接口
      // bindAdvertisementEpisode(formData).then(response => {
      //   if (response.success) {
      //     this.$message.success('绑定成功')
      //   }
      // })
    },
    /** 绑定剧集取消 */
    handleBindEpisodeCancel () {
      this.bindEpisodeVisible = false
      this.currentAdvertisementId = null
    }
  }
}
</script>

<style lang="less" scoped>
.video-preview-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
}

.video-preview-wrapper video {
  cursor: pointer;
}
</style>
